import React from "react";
import { Link } from "react-router-dom";
import DiagnosticsPanel from "../components/DiagnosticsPanel";
import Logo from "../components/Logo";

const DiagnosticsPage: React.FC = () => {
  return (
    <>
      <div className="min-h-screen bg-orange-50 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <header className="flex justify-between items-center mb-8">
            <Logo size="medium" />
            <Link
              to="/"
              className="text-orange-500 hover:text-orange-600 font-medium"
            >
              Volver a la página de inicio
            </Link>
          </header>

          <DiagnosticsPanel />
        </div>
      </div>
    </>
  );
};

export default DiagnosticsPage;
